import React, { ReactNode } from 'react';
import cx from 'classnames';

import { SectionLink } from './SectionLink';

/**
 * @typedef {LeftNavHeaderProps}
 * @property {string} activeSectionId if using scroll-able header links, this is the id of the
 * currently active section
 * @property {ReactNode} children
 * @property {HeaderSection[]} sections if using scroll-able header links, this is an array
 * of header section details
 */
interface LeftNavHeaderProps {
    activeSectionId?: string;
    children?: ReactNode;
    sections?: HeaderSection[];
}

/**
 * A header for use in the LeftNavLayout. Includes a list of <SectionLink>s that allow the user to
 * scroll down to each section. As the user scrolls into a section, that link becomes highlighted
 * to show that it is active.
 * @param props {LeftNavHeaderProps}
 */
export const LeftNavHeader = ({
    activeSectionId,
    children,
    sections = [],
}: LeftNavHeaderProps): JSX.Element => (
    <div
        className={cx('flex flex-col w-full', {
            'mt-10': sections.length < 1,
            'mt-4': sections.length > 0,
        })}
    >
        {children && <>{children}</>}
        <div className="flex mt-4 justify-between items-end">
            <div className="flex">
                {sections.map(({ id, label }: HeaderSection) => (
                    <SectionLink
                        activeSectionId={activeSectionId}
                        id={id}
                        key={id}
                        label={label}
                    />
                ))}
            </div>
        </div>
    </div>
);
